// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"CalendarHeader_mainContainer__1gbR2","arrowLeft":"CalendarHeader_arrowLeft__1ZFne","arrowRight":"CalendarHeader_arrowRight__2_e2B"};